export default __webpack_public_path__ + "static/media/clock.e7e3a3be.svg";